import React from 'react';
import {useTranslateClassName} from '../../../hooks/useTranslateClassName';

const withTranslateClassName = (WrappedComponent) => {
    const WithTranslateClassNameComponent = (props) => {
        const translateClassName = useTranslateClassName();
        
        return <WrappedComponent {...props} translateClassName={translateClassName} />;
    };
    
    WithTranslateClassNameComponent.displayName = `withTranslateClassName(${WrappedComponent.displayName || WrappedComponent.name})`;
    
    return WithTranslateClassNameComponent;
};

export default withTranslateClassName;